import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'Google map',
    defaultMessage: 'Mapa Google',
  },
  centerLat: {
    id: 'Map center latitude',
    defaultMessage: 'Latitud centre',
  },
  centerLng: {
    id: 'Map center longitude',
    defaultMessage: 'Longitud centre',
  },
  markerLat: {
    id: 'Marker latitude',
    defaultMessage: 'Latitud marcador',
  },
  markerLng: {
    id: 'Marker longitude',
    defaultMessage: 'Longitud marcador',
  },
  zoom: {
    id: 'Map zoom',
    defaultMessage: 'Zoom',
  },
  showContactCard: {
    id: 'Show contact card',
    defaultMessage: 'Mostrar targeta de contacte',
  },
});

export const GoogleMapSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.title),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: [
        'center_lat',
        'center_lng',
        'marker_lat',
        'marker_lng',
        'zoom',
        'show_contact_card',
      ],
    },
  ],
  properties: {
    center_lat: {
      title: intl.formatMessage(messages.centerLat),
      widget: 'number',
    },
    center_lng: {
      title: intl.formatMessage(messages.centerLng),
      widget: 'number',
    },
    marker_lat: {
      title: intl.formatMessage(messages.markerLat),
      widget: 'number',
    },
    marker_lng: {
      title: intl.formatMessage(messages.markerLng),
      widget: 'number',
    },
    zoom: {
      title: intl.formatMessage(messages.zoom),
      widget: 'number',
    },
    show_contact_card: {
      title: intl.formatMessage(messages.showContactCard),
      widget: 'boolean',
    },
  },
  required: [],
});
